var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2609_2179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.109375 24.5371V53.5572L18.7651 39.0472L0.109375 24.5371Z",
    fill: "#21E786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7812 16.9863V25.9087L54.2908 21.6235L48.7812 16.9863Z",
    fill: "#21E786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.057 0.385301C28.4465 -0.128434 27.5547 -0.128434 26.9441 0.385301L22.5938 4.04685H33.4073L29.057 0.385301Z",
    fill: "#21E786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21853 16.9863L1.70898 21.6235L7.21853 25.9087V16.9863Z",
    fill: "#21E786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 40.6875L2.3125 56H53.6868L33.9993 40.6875H22Z",
    fill: "#21E786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2344 39.0473L55.8902 53.5575V24.5371L37.2344 39.0473Z",
    fill: "#21E786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5862 19.6172C26.2554 19.6172 24.8789 20.9111 24.8789 23.0763C24.8789 25.2776 26.2216 26.7563 27.4757 26.7563C28.7963 26.7563 29.8792 25.2112 29.9571 23.2685L29.9592 22.856C29.9002 20.9393 28.9411 19.6172 27.5862 19.6172Z",
    fill: "#21E786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9997 37.4062L45.5 28.4615V8.96875C45.5 8.06269 44.7654 7.32812 43.8594 7.32812H12.1406C11.2346 7.32812 10.5 8.06269 10.5 8.96875V28.4616L22.0003 37.4062H33.9997ZM16.4345 26.2399C15.651 23.2611 16.045 20.1207 17.544 17.3974C19.0423 14.6751 21.484 12.6613 24.4193 11.7269C27.516 10.7408 30.8042 11.0313 33.6775 12.5448C36.5514 14.0583 38.6509 16.6041 39.5893 19.7133C39.5944 19.7302 39.5992 19.7472 39.6037 19.7643C40.2274 22.1005 40.0427 24.306 39.005 26.9151C38.3036 28.6787 36.5839 30.5632 33.861 30.5632C32.8731 30.5632 31.9258 30.1581 31.1936 29.4223C31.0204 29.2482 30.8643 29.0585 30.7245 28.8576C29.805 29.6055 28.6899 30.0382 27.4761 30.0382C25.8904 30.0382 24.3486 29.2684 23.2462 27.9262C22.1833 26.632 21.5981 24.9099 21.5981 23.0769C21.5981 21.2357 22.2208 19.532 23.3518 18.2797C24.467 17.0449 26.0106 16.3366 27.5866 16.3366C28.4534 16.3366 29.2771 16.5432 30.0172 16.9325C30.1607 16.172 30.8273 15.5974 31.6279 15.5974H31.6362C32.5422 15.6019 33.2732 16.3401 33.2687 17.2461L33.2235 26.3609C33.2221 26.6408 33.3328 26.9199 33.5196 27.1076C33.5842 27.1727 33.7146 27.2817 33.861 27.2817C35.1848 27.2817 35.7672 26.1772 35.9559 25.7024C36.7223 23.7755 36.8676 22.2584 36.4401 20.6357C35.754 18.3863 34.2308 16.5445 32.1486 15.4479C30.0591 14.3474 27.6673 14.1364 25.4146 14.8533C20.9741 16.2669 18.4235 20.9018 19.6079 25.4052C20.5914 29.1449 23.9718 31.8313 27.8285 31.938C28.7341 31.9631 29.4482 32.7177 29.4231 33.6234C29.3985 34.5137 28.6689 35.2186 27.784 35.2186C27.7686 35.2186 27.7533 35.2184 27.7377 35.218C25.1953 35.1477 22.6856 34.2445 20.6708 32.6748C18.5776 31.0442 17.1128 28.8191 16.4345 26.2399Z",
    fill: "#21E786"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2609_2179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7625f1ff08645bfe018f7838dd436dd5.svg";
export { ForwardRef as ReactComponent };